import { Operation } from '../../../__generated__/globalTypes'

import {
  ItemCategoryFragment,
  itemCategoryFragmentString,
} from '../../fragments/__generated__/ItemCategoryFragment'

import { sendDelayFragmentString } from '../../fragments/__generated__/SendDelayFragment'

import { itemFragmentString } from '../../fragments/__generated__/ItemFragment'

import { giftVariationFragmentString } from '../../fragments/__generated__/GiftVariationFragment'

import { amountString } from '../../fragments/__generated__/Amount'

import { priceString } from '../../fragments/__generated__/Price'

import getCategoryRawString from '../GetCategory.graphql'

const getCategoryString = [
  getCategoryRawString,
  itemCategoryFragmentString,
  sendDelayFragmentString,
  itemFragmentString,
  giftVariationFragmentString,
  amountString,
  priceString,
].join('\n\n')

export type GetCategoryData = {
  itemCategory: ItemCategoryFragment & {
    children: ItemCategoryFragment[]
  }
}

export type GetCategoryVariables = {
  id: string
}

export type GetCategory = Operation<GetCategoryData, GetCategoryVariables>

export const GetCategory = ({ id }: GetCategoryVariables): GetCategory => ({
  query: getCategoryString,
  variables: {
    id,
  },
})
